import { ReturnFlow } from "@redotech/redo-return-core-common/return-flow";
import { flowElementIdsOfSteps } from "@redotech/redo-return-core-common/return-flow/flow-element-id-spec";
import {
  FlowElementTextOverlay,
  FlowElementTranslatableField,
} from "@redotech/redo-return-core-common/return-flow/flow-element-translation";
import { createContext, useCallback, useContext } from "react";
import { localizeCustomerPortalFlowText } from "./util";

/** The empty default falls every lookup through to the built-in localization. */
export const FlowElementTextOverlayContext =
  createContext<FlowElementTextOverlay>({});

/**
 * Display-only, per the invariant on FlowElementTextOverlay: the merchant's
 * translation, else the Redo-default localization, else the English text.
 */
export function flowElementDisplayText(
  overlay: FlowElementTextOverlay,
  elementId: string | undefined,
  field: FlowElementTranslatableField,
  text: string,
): string {
  const translated = elementId ? overlay[elementId]?.[field] : undefined;
  return translated || localizeCustomerPortalFlowText(text);
}

export function collectFlowElementIds(
  flows: (ReturnFlow | undefined)[],
): string[] {
  return flowElementIdsOfSteps(flows.flatMap((flow) => flow?.steps ?? []));
}

export function useFlowElementText(): (
  elementId: string | undefined,
  field: FlowElementTranslatableField,
  text: string,
) => string {
  const overlay = useContext(FlowElementTextOverlayContext);
  return useCallback(
    (elementId, field, text) =>
      flowElementDisplayText(overlay, elementId, field, text),
    [overlay],
  );
}
